<template>
  <div v-if="lookups && qualification">
    <QualificationTimeLine :qualification="qualification" :key="qualificationUpdated" />
    <SubHeader title="Stage 1" />
    <b-row class="my-1">
      <b-col md="4" class="label">
        <label :for="'leadTypeId' + index">Lead Type</label>
      </b-col>
      <b-col md="8">
        <b-form-select
          :id="'leadTypeId' + index"
          :options="leadTypes"
          v-model="qualification.leadTypeId"
        >
          <template v-slot:first>
            <b-form-select-option :value="null" >-</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>

    <!-- <b-row class="my-1" v-if="qualification.leadTypeId == 30">
      <b-col md="4" class="label">
        <label :for="'tradeShowDetails' + index">Provide details of which trade show</label>
      </b-col>
      <b-col md="8">
        <b-form-textarea
          :id="'tradeShowDetails' + index"
          v-model="qualification.tradeShowDetails"
        ></b-form-textarea>
      </b-col>
    </b-row> -->

    <b-row class="my-1">
      <b-col md="4" class="label">
        <label :for="'confirmedSourceId' + index">Confirmed Source</label>
      </b-col>
      <b-col md="8">
        <b-form-select
          :id="'confirmedSourceId' + index"
          :options="sources"
          v-model="qualification.confirmedSourceId"
          value-field="id"
          text-field="name"
        >
          <template v-slot:first>
            <b-form-select-option :value="null" >-</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="4" class="label">
        <label :for="'serviceTypeId' + index">Service Type</label>
      </b-col>
      <b-col md="8">
        <b-form-select
          :id="'serviceTypeId' + index"
          :options="lookups.randDServiceType"
          v-model="qualification.serviceTypeId"
          value-field="id"
          text-field="name"
        >
          <template v-slot:first>
            <b-form-select-option :value="null" >-</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>

    <b-row class="my-1" v-if="showTradeShowDetails()">
      <b-col md="4" class="label">
        <label :for="'tradeShowDetails' + index">Provide details of which trade show</label>
      </b-col>
      <b-col md="8">
        <b-form-textarea
          :id="'tradeShowDetails' + index"
          v-model="qualification.tradeShowDetails"
        ></b-form-textarea>
      </b-col>
    </b-row>

    <b-row class="my-1" v-if="showReferrer()">
      <b-col md="4" class="label">
        <label :for="'referralUserId' + index">Referral User</label>
      </b-col>
      <b-col md="8">
        <b-form-select
          :id="'referralUserId' + index"
          :options="referrers"
          v-model="qualification.referralUserId"
          value-field="id"
          text-field="fullName"
        >
          <template v-slot:first>
            <b-form-select-option :value="null" >-</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="4" class="label">
        <label :for="'qualifierId' + index">randd Qualifier</label>
      </b-col>
      <b-col md="8">
        <b-form-select
          :id="'qualifierId' + index"
          :showClearButton='true'
          :options="lookups.qualifiers"
          v-model="qualification.qualifierId"
          value-field="id"
          text-field="fullName"
        >
          <template v-slot:first>
            <b-form-select-option :value="null" >-</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="4" class="label">
        <label :for="'quallifierCallbackInfo' + index">Qualifier to call back info</label>
      </b-col>
      <b-col md="8">
        <b-form-group
        description="If qualifier is to call back the client, remember to set a callback for the qualifier">
          <b-form-textarea
            :id="'quallifierCallbackInfo' + index"
            v-model="qualification.quallifierCallbackInfo"
          ></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="4" class="label">
        <label :for="'generatorId' + index">randd Generator</label>
      </b-col>
      <b-col md="8">
        <b-form-select
          :id="'generatorId' + index"
          :options="lookups.generators"
          v-model="qualification.generatorUserId"
          value-field="id"
          text-field="fullName"
        >
          <template v-slot:first>
            <b-form-select-option :value="null" >-</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="4" class="label">
        <label :for="'hasMadeBespokeProducts' + index">
          Have you made any bespoke or customised products, processes, or software?
        </label>
      </b-col>
      <b-col md="8">
        <b-form-group description="This includes investing in or developing any new or existing projects / products including those that may have failed.
        In-house or contracted out. NB : CRM &amp; website developments usually don’t qualify unless it’s really complex">
          <b-form-select
            :id="'hasMadeBespokeProducts' + index"
            v-model="qualification.hasMadeBespokeProducts"
            rows="3"
            :options="yesNo"
            value-field="id"
            text-field="title"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="4" class="label">
        <label :for="'hasMadeEnviromentalImprovements' + index">
          Have you made any environmental improvements to your process?
        </label>
      </b-col>
      <b-col md="8">
        <b-form-group description="Energy saving methods, waste reduction, recycling of materials, reducing / zeroing your carbon footprint">
          <b-form-select
            :id="'hasMadeEnviromentalImprovements' + index"
            v-model="qualification.hasMadeEnviromentalImprovements"
            rows="3"
            :options="yesNo"
            value-field="id"
            text-field="title"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="4" class="label">
        <label :for="'additionalDetails' + index">
          Please provide any extra detail from above questions
        </label>
      </b-col>
      <b-col md="8">
        <b-form-textarea
          :id="'additionalDetails' + index"
          v-model="qualification.additionalDetails"
          rows="3"
        ></b-form-textarea>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="4" class="label">
        <label :for="'howLong' + index">
          How long have you been making improvements to your existing products, processes, or services?
        </label>
      </b-col>
      <b-col md="8">
        <b-form-textarea
          :id="'howLong' + index"
          v-model="qualification.howLong"
          rows="3"
        ></b-form-textarea>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="4" class="label">
        <label :for="'existingPatents' + index">
          Does your company have any existing patents on products or processes, or considering applying?
        </label>
      </b-col>
      <b-col md="8">
        <b-form-group>
          <b-form-select
            :id="'existingPatents' + index"
            v-model="qualification.existingPatents"
            rows="3"
            :options="yesNo"
            value-field="id"
            text-field="title"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="my-1" v-if="qualification.existingPatents == true">
      <b-col md="4" class="label">
        <label :for="'existingPatentsDetails' + index">
          Please provide any extra detail on from above questions
        </label>
      </b-col>
      <b-col md="8">
        <b-form-textarea
          :id="'existingPatentsDetails' + index"
          v-model="qualification.existingPatentsDetails"
          rows="3"
        ></b-form-textarea>
      </b-col>
    </b-row>


    <b-row class="my-1">
      <b-col md="4" class="label">
        <label :for="'hasClaimedRnDCredits' + index">
          Have you ever claimed R&amp;D tax credits before?
        </label>
      </b-col>
      <b-col md="8">
        <b-form-group>
          <b-form-select
            :id="'hasClaimedRnDCredits' + index"
            v-model="qualification.hasClaimedRnDCredits"
            rows="3"
            :options="yesNo"
            value-field="id"
            text-field="title"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="my-1" v-if="qualification.hasClaimedRnDCredits == true">
      <b-col md="4" class="label">
        <label :for="'claimPersonId' + index">
          Who carried out the claim?
        </label>
      </b-col>
      <b-col md="8">
        <b-form-group>
          <b-form-select
            :id="'claimPersonId' + index"
            v-model="qualification.claimPersonId"
            rows="3"
            :options="caimPeople"
            value-field="id"
            text-field="title"
          >
            <template v-slot:first>
              
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="my-1" v-if="qualification.hasClaimedRnDCredits == true">
      <b-col md="4" class="label">
        <label :for="'whenWasLastClaimId' + index">
          When was your last claim?
        </label>
      </b-col>
      <b-col md="8">
        <b-form-group>
          <b-form-select
            :id="'whenWasLastClaimId' + index"
            v-model="qualification.whenWasLastClaimId"
            rows="3"
            :options="lastClaim"
            value-field="id"
            text-field="title"
          >
            <template v-slot:first>
              <b-form-select-option :value="null" >-</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="3">
        <label for="input-none"></label>
      </b-col>
      <b-col md="9">
        <b-button
          type="submit"
          variant="success"
          class="margin-right margin-sm-bottom"
          @click="save"
          :disabled="qualification.isComplete"
        >
          <font-awesome-icon icon="save" /> Save
        </b-button>
        <b-button
          type="reset"
          variant="danger"
          class="margin-right margin-sm-bottom"
          @click="reset"
          :disabled="qualification.isComplete"
        >
          <font-awesome-icon icon="times" /> Cancel Changes
        </b-button>
        <br />
        <b-button
          type="reset"
          variant="primary"
          class="margin-right"
          @click="transferSend"
          :disabled="
            qualification.id == 0 ||
            qualification.qualifierId == null ||
            qualification.isComplete ||
            qualification.transferedDateTime != null
          "
        >
          <font-awesome-icon icon="envelope" /> Transfer, Send Qualification
        </b-button>
        <b-button
          type="reset"
          variant="primary"
          @click="transfer"
          :disabled="
            qualification.id == 0 ||
            qualification.isComplete ||
            qualification.qualifierId == null ||
            qualification.transferedDateTime != null
          "
        >
          <font-awesome-icon icon="exchange" /> Live Transfer
        </b-button>
      </b-col>
    </b-row>
    <b-row class="my-1">
      <b-col md="3">
      </b-col>
      <b-col md="6">
        <Feedback ref="saveFeedback"/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SubHeader from "@/components/shared/SubHeader.vue";
import QualificationTimeLine from "@/components/company/qualification/QualificationTimeLine.vue";
import CompanyService from '@/services/Company.service';
import Feedback from "@/components/shared/Feedback.vue";
import DataSelectionService from "@/services/DataSelection.service";

export default {
  components: { SubHeader, QualificationTimeLine, Feedback },
  props: {
    company: Object,
    initialQualification: Object,
    lookups: Object,
    index: Number
  },
  mounted() {
    if (this.initialQualification && this.qualification == null) {
      this.qualification = {...this.initialQualification};
    }
    
    this.fixQualificationLookup();
    this.fixGeneratorLookup();
    
  },
  watch: {
    initialCompany: function() {
      this.qualification = {...this.initialQualification};
    },
  },
  data() {
    return {
      qualification: null,
      selectedCompanyId: null,
      yesNo: [{ id: null, title: "-"}, { id: true, title: "Yes"}, { id: false, title: "No"}],
      caimPeople: [{ id: null, title: "-"}, { id: 1, title: "Yourself"}, { id: 2, title: "Accountant"}, { id: 3, title: "R&D Agent"}],
      lastClaim: [ { id: 1, title: "Last Year"}, { id: 2, title: "1-2 Years"}, { id: 3, title: "2 years +"}],
      leadTypes: [
        {value: 10, text: "Inbound" },
        {value: 20, text: "Outbound" },
        {value: 30, text: "Referral" }
      ],
      qualificationUpdated: 0
    };
  },
  computed: {
    sources() {
      if (!this.qualification || !this.qualification.leadTypeId || !this.lookups) return [];

      if (this.qualification.leadTypeId == 10) {
        return this.lookups.sources.filter(x => x.inbound)
      } else if (this.qualification.leadTypeId == 20) {
        return this.lookups.sources.filter(x => x.outbound)
      } else if (this.qualification.leadTypeId == 30) {
        
        return this.lookups.sources.filter(x => x.isReferral)
        
      }

      return [];
    },
    referrers() {

      if(!this.qualification || !this.qualification.leadTypeId || !this.lookups) return [];

      var currentSource = this.lookups.sources.filter(x => x.id == this.qualification.confirmedSourceId)

      switch(currentSource[0].name) {
        case 'Randd Referral':
          return this.lookups.referrers.filter(x => x.isRanddUser);
        case 'KBS Referral':
          this.fixReffererLookup();
          return this.lookups.referrers.filter(x => x.isKBSCorporate);
        case 'Knightsbridge Referral':
          return this.lookups.referrers.filter(x => x.isKnightsbridge);
        case 'ONE80 Referral':
          return this.lookups.referrers.filter(x => x.isOne80User);
        default:
          return this.lookups.referrers;
      }
     
    }

  },
  methods: {

    showReferrer() {
      if(!this.qualification || !this.qualification.leadTypeId || !this.lookups) return false;

      var currentSource = this.lookups.sources.filter(x => x.id == this.qualification.confirmedSourceId)

      if (!currentSource || currentSource.length == 0) return false;

      switch(currentSource[0].name) {
        case 'Randd Referral':
        case 'KBS Referral':
        case 'Knightsbridge Referral':
        case 'ONE80 Referral':
          return true;
        default:
          return false;
      }
      
    },
    showTradeShowDetails() {
      if(!this.qualification || !this.qualification.leadTypeId || !this.lookups) return false;

      var currentSource = this.lookups.sources.filter(x => x.id == this.qualification.confirmedSourceId)

      if (!currentSource || currentSource.length == 0) return false;

      if (currentSource[0].name == 'Trade Show') return true;

      return false;
    },
    fixQualificationLookup()
    {
      var qualifierFound = false;
      if (this.qualification.qualifierId != null)
      {
        var qualifierID = this.qualification.qualifierId;
        var qualifierFull = this.qualification.qualifierString + " - Deleted";
        this.lookups.qualifiers.forEach(function(qualifier) {
          if (qualifierID == qualifier.id)
          {
            qualifierFound = true;
          }
        });
        if (qualifierFound == false)
        {
          const newObj = { id: qualifierID, fullName: qualifierFull };
          this.lookups.qualifiers.push(newObj);
        }
      }
    },
    fixGeneratorLookup()
    {
      var generatorFound = false;
      if (this.qualification.generatorUserId != null)
      {
        var generatorID = this.qualification.generatorUserId;
        var generatorFull = this.qualification.generatorUserString + " - Deleted";
        this.lookups.generators.forEach(function(generator) {
          if (generatorID == generator.id)
          {
            generatorFound = true;
          }
        });
        if (generatorFound == false)
        {
          const newObj = { id: generatorID, fullName: generatorFull };
          this.lookups.generators.push(newObj);
        }
      }
    },
    fixReffererLookup()
    {
      var referrerFound = false;
      
      if (this.qualification.referralUserId != null)
      {
        var referrerID = this.qualification.referralUserId;
        var referralUserString = this.qualification.referralUserString + " - Deleted";
        
        this.lookups.referrers.forEach(function(referrer) {
          if (referrerID == referrer.id)
          {
            referrerFound = true;
          }
        });
        if (referrerFound == false)
        {
          const newObj = { id: referrerID, fullName: referralUserString, isRanddUser: this.qualification.referralUser.isRandDUser, isKBSCorporate: this.qualification.referralUser.isKbscorporateUser, isOne80User : this.qualification.referralUser.isOne80User, isKnightsbridge: this.qualification.referralUser.isKnightsbridgeUser };
          this.lookups.referrers.push(newObj);
        }
      }
    },
    reset() {
      this.qualification = {...this.initialQualification}
    },
    transfer() {
      this.save();
      this.$parent.$parent.transferCompany(this.qualification.companyId);
    },
    transferSend() {
      CompanyService.saveCompanyQualifications(this.qualification).then(() => {
        CompanyService.sendTransfer(this.qualification.id).then(() => {
          //this.qualification.transferedToQuantumaDateTime = new Date();
          if (!this.qualification.transferedDate) {
            this.qualification.transferedDate = new Date();
            this.qualificationUpdated++;
          }
          
          console.log('After ' + this.qualification.transferedDate);
          this.$refs.saveFeedback.showSuccess("Transfer Successful");

          if(this.$route.name == "CompanyCall") {
            DataSelectionService.getNextCompany().then(result => {
              if(result && result.data != 0) {
                this.$router.push("/call/" + result.data);

              } else {
                this.$router.push("/getnext");
              }
            });

          } else {
            this.$parent.$parent.$parent.$parent.$parent.loadData();
          }

        });
      });
    },
    save() {
      CompanyService.saveCompanyQualifications(this.qualification).then(() => {

        this.$refs.saveFeedback.showSuccess("Save Successful");
        this.$parent.$parent.$parent.$parent.$parent.loadData();
      })
    },
    /*showModal() {
      this.$refs["modal"].show();
    },
    hideModal() {
      this.$refs["modal"].hide();
    },*/
  }
};
</script>

<style scoped>
.label {
  text-align: right;
}
.label > label {
  margin-top: 6px;
}
</style>
